import api from '../utils/api';

/** Matches backend VendorDocument / vendor.vendorRole for filtering */
export const VENDOR_TYPE = {
  CLINIC: 2,
  MEDICAL_STORE: 3,
  AMBULANCE_AGENCY: 4,
} as const;

export type VendorDocumentRow = {
  documentId: string;
  vendorId: string;
  vendorType: number;
  documentType: string;
  documentName: string;
  documentNumber?: string | null;
  documentUrl: string;
  documentMimeType?: string | null;
  issuedBy?: string | null;
  issuedDate?: string | null;
  expiryDate?: string | null;
  isLifetime?: boolean;
  status?: string;
  isVerified?: boolean;
  uploadedAt?: string;
};

export async function fetchVendorDocuments(
  vendorId: string,
  vendorType: number
): Promise<VendorDocumentRow[]> {
  const response = await api.get<{ success?: boolean; documents?: VendorDocumentRow[] }>(
    '/medicine-delivery/vendor-documents',
    {
      params: { vendorId, vendorType },
    }
  );
  const list = response.data?.documents;
  return Array.isArray(list) ? list : [];
}

export async function setVendorDocumentVerification(
  documentId: string,
  verify: boolean
): Promise<VendorDocumentRow | null> {
  const response = await api.patch<{ success?: boolean; document?: VendorDocumentRow }>(
    `/medicine-delivery/vendor-documents/${encodeURIComponent(documentId)}/verify`,
    { verify }
  );
  return response.data?.document ?? null;
}

export async function adminUploadOrReplaceVendorDocument(
  formData: FormData
): Promise<VendorDocumentRow | null> {
  const response = await api.post<{ success?: boolean; document?: VendorDocumentRow }>(
    '/master-admin/vendor-documents/upload-or-replace',
    formData,
    {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    }
  );
  return response.data?.document ?? null;
}

export async function updateDocumentExpiryDate(
  documentId: string,
  payload: { expiryDate?: string | null; issuedDate?: string | null; isLifetime?: boolean }
): Promise<VendorDocumentRow | null> {
  const response = await api.patch<{ success?: boolean; document?: VendorDocumentRow }>(
    `/master-admin/vendor-documents/${encodeURIComponent(documentId)}/expiry`,
    payload
  );
  return response.data?.document ?? null;
}
